import moment from 'moment'
import uns from "underscore.string"

const Formatter = function() {

    this.dateYMD = function(itemDate) {
        return moment(itemDate).format("YYYY-MM-DD")
    }

    this.dateYMDHHmm = function(itemDate) {
        return moment(itemDate).format("YYYY-MM-DD HH:mm")
    }

    this.priceZl = function(price) {
        return `${price} zł`;
    }

    this.clearZL = function(formattedPrice) {
        return uns.replaceAll(formattedPrice,
            "zł",""
        )
    }

    return {
        "price": {
            "ZL": this.priceZl,
            "clearZL": this.clearZL
        },
        "date": {
            "YMD": this.dateYMD,
            "YMDHHmm": this.dateYMDHHmm
        }
    }
}

export default Formatter


// WEBPACK FOOTER //
// ./src/service/Formatter.js